"use client";

import { useState } from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { Button } from "@/components/shared";
import { Close, Add } from "@platzi/icons";
import { ModalContent } from "./ModalContent";
import styles from "./AddAdministrator.module.sass";

export const AddAdministrator = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className={styles.AddAdministrator}>
      <Dialog.Root open={open} onOpenChange={setOpen}>
        <Dialog.Trigger asChild>
          <Button size="lg" dataQa="add-student-btn">
            <Add /> Asignar nuevo administrador
          </Button>
        </Dialog.Trigger>
        <Dialog.Portal>
          <Dialog.Overlay className={styles.DialogOverlay} />
          <Dialog.Content className={styles.DialogContent}>
            <ModalContent onSubmit={setOpen} />
            <Dialog.Close asChild>
              <button className={styles.CloseButton} aria-label="Close">
                <Close />
              </button>
            </Dialog.Close>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>
    </div>
  );
};
